import { useQuery } from '@apollo/client'

import { EXPORT_POLICY_UPDATER_QUERY } from '../../graphql/adminConfig'
import { getTranslate } from '../../localization'

interface UpdaterData {
  user: { name: string; username: string } | null
}

export default function UpdatedByName({
  userID
}: {
  userID: string
}): JSX.Element {
  const isMigration = userID.startsWith('migration:')
  const isUserID = /^[a-f\d]{24}$/i.test(userID)
  const { data, loading, error } = useQuery<UpdaterData>(
    EXPORT_POLICY_UPDATER_QUERY,
    {
      variables: { userID },
      skip: !isUserID,
      fetchPolicy: 'network-only'
    }
  )

  const name = !error && isUserID && data?.user?.name?.trim()
  const username = !error && isUserID && data?.user?.username?.trim()
  let label = name || username || getTranslate('User unavailable')
  if (isMigration) label = getTranslate('System migration')
  else if (isUserID && loading) label = getTranslate('Loading user…')

  return <span role="status">{label}</span>
}
